import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        name_label: { default: "Patient (or person authorized to sign for patient)" },
        date_label: { default: "Date" },
        signature_label: { default: "Signature" },
        
        name: { type: String },
        date: { type: Date },
        signature: { type: null },
        
        name_rules: { type: Array, default: [] },
        date_rules: { type: Array, default: [] },
        signature_rules: { type: Array, default: [] }        
    },
    data() {
        return {
            _name: this.name,
            _date: this.date,
            _signature: this.signature
        };
    },
    watch: {
        _name(newval, oldval) {
            this.$emit('update:name', newval);
        },
        _date(newval, oldval) {
            this.$emit('update:date', newval);            
        },
        _signature(newval, oldval) {
            this.$emit('update:signature', newval);
        }
    },
    methods: {
        
    }
});
